module.exports = __webpack_public_path__ + "static/media/Ally_web_2.f2980f91.jpg";